(function () {

    'use strict';
    angular.module('iplusjs.inputNumber', [
        'lodash',
        'numbro',
        'iplusjs.utils.misc',
        'iplusjs.fieldset'
    ])
        .directive('iplusjsInputNumber', inputNumber);

    inputNumber.$inject = [
        '$log',
        'lodash',
        'MiscUtilsService',
        'numbro'
    ];
    function inputNumber($log, _, MiscUtilsService, numbro) {
        return {
            restrict: 'A',
            require: ['ngModel', '^?iplusjsFieldset'],
            link: function ($scope, $element, $attrs, ctrls) {
                var $ngModel = ctrls[0],
                    fieldsetCtrl = ctrls[1],
                    formatMask = $attrs.iinFormatMask || '0,0.00', // mit 2 Dezimalstellen
                    precision = parseInt($attrs.iinPrecision, 10) || 0, // ohne Dezimalstellen
                    multiplyBy = parseInt($attrs.iinMultiplyBy, 10) || 1, // ohne Dezimalstellen
                    formatModel = $scope.$eval($attrs.iinFormatModel) || false,
                    formatViewOnChange = $scope.$eval($attrs.iinFormatViewOnChange),
                    roundToMinMax = $scope.$eval($attrs.iinRoundToMinMax),
                    regexNumber = /([0-9,.]*)/g,
                    minVal,
                    maxVal;

                formatViewOnChange = _.isNil(formatViewOnChange) ? true : formatViewOnChange;
                roundToMinMax = _.isNil(roundToMinMax) ? true : roundToMinMax;

                function _round(value, precision) {
                    var multiplier = Math.pow(10, precision || 0);
                    return Math.round(value * multiplier) / multiplier;
                }

                function _toNumberValue(value) {
                    if (
                        (!_.isNil(minVal) && !roundToMinMax && parseFloat(value, 10) < minVal) ||
                        (!_.isNil(maxVal) && !roundToMinMax && parseFloat(value, 10) > maxVal)
                    ) {
                        return parseFloat(numbro().unformat(value), 10);
                    }

                    return _round(numbro().unformat(value), precision);
                }

                function _getValue(modelValue, viewValue) {
                    var val = MiscUtilsService.getValueCustomObject(MiscUtilsService.isEmpty(modelValue) ? viewValue : modelValue);

                    if (formatModel) {
                        val = numbro().unformat(val);
                    } else if (MiscUtilsService.isEmpty(modelValue) && formatViewOnChange) {
                        val = !_.isEmpty(_.replace(val, regexNumber, '')) ? val : numbro(val).value();
                    }

                    return val;
                }

                function toView(value) {
                    return MiscUtilsService.isEmpty(value) || _.isNaN(value) || _.isNaN(numbro(value).value()) || formatModel ? value : numbro(_round(value, precision)).divide(multiplyBy).format(formatMask);
                }

                function toModel(value) {
                    if (MiscUtilsService.isNotEmpty(value)) {
                        var formatedValue = numbro(_toNumberValue(value)).format(formatMask);

                        if (formatedValue === 'NaN' || !numbro.validate(value)) {
                            return value;
                        }

                        if (value !== formatedValue && formatViewOnChange) {
                            $ngModel.$viewValue = formatedValue;
                            $ngModel.$setViewValue(formatedValue);
                            $ngModel.$commitViewValue();
                            $ngModel.$render();
                        }
                    }

                    return MiscUtilsService.isEmpty(value) ? value : formatModel ? formatedValue : numbro(_toNumberValue(value)).multiply(multiplyBy).value();
                }

                function isDisabled() {
                    return ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled));
                }

                function numberValidator(modelValue, viewValue) {
                    var val = _getValue(modelValue, viewValue);

                    if (isDisabled()) {
                        return true;
                    }

                    return MiscUtilsService.isEmpty(val) || !_.isNaN(_.toNumber(val));
                }

                function minValidator(modelValue, viewValue) {
                    var val = _getValue(modelValue, viewValue);

                    if (isDisabled()) {
                        return true;
                    }

                    if (!numberValidator(modelValue, viewValue)) {
                        return;
                    }

                    return MiscUtilsService.isEmpty(val) || _.isUndefined(minVal) || val >= minVal;
                }

                function maxValidator(modelValue, viewValue) {
                    var val = _getValue(modelValue, viewValue);

                    if (isDisabled()) {
                        return true;
                    }

                    if (!numberValidator(modelValue, viewValue)) {
                        return;
                    }

                    return MiscUtilsService.isEmpty(val) || _.isUndefined(maxVal) || val <= maxVal;
                }

                $ngModel.$validators.number = numberValidator;

                if (!_.isUndefined($attrs.iinMin)) {
                    $ngModel.$validators.min = minValidator;

                    $attrs.$observe('iinMin', function (val) {
                        val = parseFloat(val, 10);
                        minVal = _.isNumber(val) && !_.isNaN(val) ? val : undefined;

                        $ngModel.$validate();
                    });
                }

                if (!_.isUndefined($attrs.iinMax)) {
                    $ngModel.$validators.max = maxValidator;

                    $attrs.$observe('iinMax', function (val) {
                        val = parseFloat(val, 10);
                        maxVal = _.isNumber(val) && !_.isNaN(val) ? val : undefined;

                        $ngModel.$validate();
                    });
                }

                $ngModel.$formatters.unshift(toView);
                $ngModel.$parsers.push(toModel);
            }
        };
    }

})();
